/**
 * @module editor-inline-cc
 */
import InlineEditorCC from './inlineEditorCC.js';

export default InlineEditorCC;
